import React, { ReactElement } from 'react';

import TDropdownFormControlProps from './types/TDropdownFormControlProps';
import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import componentName from './name';

function DropdownFormControl({
  isDirty,
  isEmpty,
  isErrored,
  isFocused,
  isHovered,
  isTouched,
  ...rest
}: TDropdownFormControlProps): ReactElement {
  const conditionalProps = filterConditionalKeyValues({
    states: [
      isDirty && 'dirty',
      !isEmpty && 'filled',
      isErrored && 'errored',
      isFocused && 'focused',
      isHovered && 'hovered',
      isTouched && 'touched',
    ],
  });

  return <Box {...rest} {...conditionalProps} as="div" name="formControl" parent={componentName} />;
}

export default DropdownFormControl;
